module.exports = __webpack_public_path__ + "static/media/g2-class@2x.fc3b6a33.png";